import { ref, onMounted, computed, watch } from "vue";
import CommonFooter from "@/components/commonFooter/index.vue";
import CommonHeader from "@/components/commonHeader/index.vue";
import { jointPlanApi, projectDocUploadUrl } from "../../../../api/commonApi";
import { useRouter } from "vue-router";
import { SUCCEED_CODE, userRoleType } from "@/constants";
import { ElMessage, ElLoading } from "element-plus";
import {
  contractManage,
  orderManage,
  acceptanceManage,
  settleManage,
  acceptStatusDic,
  paymentMethodDic,
  pricingMethodDic,
  supplierRecords,
  purchaseRecords,
} from "./config";
import { exportMaterialUrls } from "@/constants/index.js";

export default {
  name: "ContractPeformDetail",
  components: {
    CommonFooter,
    CommonHeader,
  },
  setup() {
    const router = useRouter();
    const renderDom = ref({});
    const routeParams = ref({});
    const detailData = ref({
      contractName: "",
      projectName: "",
      purchaserEnterpriseName: "",
      firstParty: "",
      secondParty: "",
      supplierEnterpriseName: "",
      amount: "",
      selectCategoryCodes: "",
      startDate: "",
      pricingMethod: "",
      remarks: "",
      lcContractAttachmentIdList: "",
    });
    const currentProcess = ref({
      title: "",
      data: [],
    });
    const currentEditProcess = ref({});
    const currentEditProcessData = ref({});
    const processModal = ref(false);
    // const userRole = computed(() => localStorage.getItem("userRole"));
    const userRole = ref(localStorage.getItem("userRole"));
    const disabled = ref(true);
    const currentEditProcessRef = ref();
    const currentProcessId = ref("");
    // 编辑表格
    const editTableIndex = ref(-1);
    const editTabeRef = ref();
    // 编辑表格数据
    const editTableData = ref({
      acceptCount: null,
      acceptTaxPrice: null,
      realityPrice: null,
    });
    const formRef = ref();
    // 联采id
    const lcPlanId = computed(() => sessionStorage.getItem("lcPlanId"));

    onMounted(() => {
      routeParams.value = router.currentRoute.value.query;
      userRole.value = localStorage.getItem("userRole");
      setRenderDom();
    });

    watch(
      editTableData,
      () => {
        editTableData.value.taxTotalPrice =
          editTableData.value.taxPrice * editTableData.value.settlementCount;
      },
      { deep: true }
    );

    const setRenderDom = () => {
      switch (routeParams.value.type) {
        case "1":
          renderDom.value = contractManage;
          routeParams.value.id && contractDetail();

          break;
        case "2":
          renderDom.value = orderManage;
          routeParams.value.id && orderDetail();

          break;
        case "3":
          renderDom.value = acceptanceManage;
          routeParams.value.id && acceptDetail();

          break;
        case "4":
          renderDom.value = settleManage;
          routeParams.value.id && settlementDetail();

          break;

        default:
          break;
      }
    };

    // 合同详情
    const contractDetail = () => {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      jointPlanApi
        .contractDetail({ lcContractId: routeParams.value.id })
        .then((res) => {
          loadingInstance.close();
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            detailData.value = data;
            Array.isArray(data.categoryNameList) && data.categoryNameList.length
              ? (detailData.value.categoryNameList =
                  data.categoryNameList.join("，"))
              : "";
            if (
              Array.isArray(data.materialPriceList) &&
              data.materialPriceList.length
            ) {
              const materialTotal = {
                number: "合计",
                purchaseCount: data.purchaseTotalCount,
                taxTotalPrice: data.taxTotalPrice,
              };
              detailData.value.materialPriceList.unshift(materialTotal);
            }
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 订单详情
    const orderDetail = () => {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      jointPlanApi
        .orderDetail({ lcOrderId: routeParams.value.id })
        .then((res) => {
          loadingInstance.close();
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            detailData.value = data;
            if (
              Array.isArray(data.materialPriceList) &&
              data.materialPriceList.length
            ) {
              const materialTotal = {
                number: "合计",
                orderCount: data.orderTotalCount,
                taxTotalPrice: data.taxTotalPrice,
              };
              detailData.value.materialPriceList.unshift(materialTotal);
            }
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 验收单详情
    const acceptDetail = () => {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      jointPlanApi
        .acceptDetail({ lcAcceptId: routeParams.value.id })
        .then((res) => {
          loadingInstance.close();
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            detailData.value = data;
            disabled.value =
              data.acceptStatus > 0 || userRole.value === userRoleType.supplier;
            if (
              Array.isArray(data.materialPriceList) &&
              data.materialPriceList.length
            ) {
              const materialTotal = {
                number: "合计",
                orderCount: data.orderTotalCount,
                taxTotalPrice: data.taxTotalPrice,
                acceptCount: data.acceptTotalCount,
                realityPrice: data.realityTotalPrice,
              };
              detailData.value.materialPriceList.unshift(materialTotal);
            }
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 结算单详情
    const settlementDetail = () => {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      jointPlanApi
        .settlementDetail({ lcSettlementId: routeParams.value.id })
        .then((res) => {
          loadingInstance.close();
          const { data, statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            detailData.value = data;
            detailData.value.paymentVoucherFileList = data.paymentVoucherFile
              ? [data.paymentVoucherFile]
              : [];
            detailData.value.paymentVoucherFileId =
              data.paymentVoucherFile?.id || "";
            disabled.value =
              data.settlementStatus > 3 ||
              userRole.value === userRoleType.supplier;
            if (
              Array.isArray(data.materialPriceList) &&
              data.materialPriceList.length
            ) {
              const materialTotal = {
                number: "合计",
                settlementCount: data.settlementTotalCount,
                taxTotalPrice: data.taxTotalPrice,
              };
              detailData.value.materialPriceList.unshift(materialTotal);
            }
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 导出报价清单
    const handleDownloadFile = () => {
      switch (routeParams.value.type) {
        case "1":
          window.open(
            exportMaterialUrls.contractUrl +
              "?lcContractId=" +
              routeParams.value.id,
            "_blank"
          );
          break;
        case "2":
          window.open(
            exportMaterialUrls.orderUrl + "?lcOrderId=" + routeParams.value.id,
            "_blank"
          );
          break;
        case "3":
          window.open(
            exportMaterialUrls.acceptUrl +
              "?lcAcceptId=" +
              routeParams.value.id,
            "_blank"
          );
          break;
        case "4":
          window.open(
            exportMaterialUrls.settleUrl +
              "?lcSettlementId=" +
              routeParams.value.id,
            "_blank"
          );
          break;

        default:
          break;
      }
    };

    //
    const processVisible = (process) => {
      if (
        (process.progressName === "作废" && !process.operationTime) ||
        (process.progressName === "取消订单" && !process.operationTime)
      ) {
        return false;
      } else {
        return true;
      }
    };

    /**
     * 设定流程内容
     * @param {*} process 流程内容
     */
    const setCurrentProcess = (process, index) => {
      localStorage.getItem("userRole");
      currentProcessId.value = process.id;
      if (process.operationTime) {
        // 已操作
        currentProcess.value = {
          title: process.progressName,
          data: Array.isArray(JSON.parse(process.data))
            ? JSON.parse(process.data)
            : [JSON.parse(process.data)],
        };
        processModal.value = true;
      } else if (process.progressName === "验收") {
        ElMessage.warning("暂无验收信息！");
      } else if (
        index === 0 ||
        process.progressName === "验收不通过" ||
        detailData.value.agreeProgressList[index - 1].operationTime
      ) {
        if (userRole.value === userRoleType.purchaser) {
          currentEditProcess.value = purchaseRecords.find(
            (item) => item.name === process.progressName
          );
          currentProcess.value.title = process.progressName;
        } else {
          currentEditProcess.value = supplierRecords.find(
            (item) => item.name === process.progressName
          );
          currentProcess.value.title = process.progressName;
        }
        if (currentEditProcess.value) {
          currentEditProcessData.value = JSON.parse(
            JSON.stringify(currentEditProcess.value.commitData)
          );
          processModal.value = true;
        } else {
          ElMessage.warning("无操作权限！");
        }
      } else {
        ElMessage.warning("请完成上一步操作！");
      }
    };

    const closeModal = () => {
      processModal.value = false;
      currentProcess.value = {
        title: "",
        data: [],
      };
      currentEditProcessData.value = {};
      currentEditProcess.value = {};
    };

    // 操作进度状态
    const commitEditProcess = async (formEl) => {
      if (!formEl) return;
      await formEl.validate((valid) => {
        if (valid) {
          let dataStringify = {};
          currentEditProcess.value.modalContent.forEach((item) => {
            if (item.key !== "operationTime") {
              if (
                Array.isArray(currentEditProcessData.value[item.key]) &&
                item.key !== "files"
              ) {
                dataStringify[item.label] =
                  currentEditProcessData.value[item.key].join("-");
              } else {
                dataStringify[item.label] =
                  currentEditProcessData.value[item.key];
              }
            }
          });
          let params = {
            id: currentProcessId.value,
            operationTime: currentEditProcessData.value.operationTime,
            data: JSON.stringify(dataStringify),
          };
          updateAgreeProgress(params);
        }
      });
    };

    // 更新进度状态
    const updateAgreeProgress = (params) => {
      jointPlanApi.updateAgreeProgress(params).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success("操作成功！" || message);
          closeModal();
          setRenderDom();
        } else {
          ElMessage.error("操作失败！" || message);
        }
      });
    };

    // 上传进程文件
    const uploadProgressFile = (files, res) => {
      const { statusCode, message } = res;
      if (statusCode === SUCCEED_CODE) {
        currentEditProcessData.value.files = files.map((item) => {
          return {
            [item.response.data[0]?.fileName]: item.response.data[0]?.filePath,
          };
        });
        ElMessage.success(message || "上传成功！");
      } else {
        ElMessage.error(message || "上传失败！");
      }
    };

    //
    const removeProgressFile = (files) => {
      currentEditProcessData.value.files = files.map((item) => {
        return {
          [item.response.data[0]?.fileName]: item.response.data[0]?.filePath,
        };
      });
    };

    // 新增-编辑验收单材料价格
    const saveOrUpdateAcceptMaterial = () => {
      jointPlanApi
        .saveOrUpdateAcceptMaterial(editTableData.value)
        .then((res) => {
          const { statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            ElMessage.success(message);
            acceptDetail();
            editTableIndex.value = -1;
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 新增-编辑结算单材料价格
    const saveOrUpdateSettlementMaterial = () => {
      jointPlanApi
        .saveOrUpdateSettlementMaterial(editTableData.value)
        .then((res) => {
          const { statusCode, message } = res;
          if (statusCode === SUCCEED_CODE) {
            ElMessage.success(message);
            settlementDetail();
            editTableIndex.value = -1;
          } else {
            ElMessage.error(message);
          }
        });
    };

    // 编辑表格列
    const setTableEditRow = (index, row) => {
      if (index) {
        editTableData.value = row;
        editTableIndex.value = index;
      }
    };

    //
    const cancelEditRow = () => {
      editTableIndex.value = -1;
    };

    // 保存材料表格编辑框
    const handleSaveTableEditRow = async () => {
      if (!editTabeRef.value) return;
      await editTabeRef.value[0].validate((valid) => {
        if (valid) {
          switch (routeParams.value.type) {
            case "3":
              saveOrUpdateAcceptMaterial();
              break;
            case "4":
              saveOrUpdateSettlementMaterial();
              break;

            default:
              break;
          }
        }
      });
    };

    // 上传付款凭证
    const uploadSuccess = (response, file, fileList, type) => {
      switch (type) {
        case "paymentVoucherFileList":
          detailData.value.paymentVoucherFileId = response?.data[0]?.id;
          detailData.value.paymentVoucherFileList = [
            {
              ...response?.data[0],
              name: response?.data[0].fileName,
              path: response?.data[0].filePath,
            },
          ];
          break;

        case "invoiceFileIdList":
          detailData.value.invoiceFileIdList = fileList.map((item) => {
            return item.response.data[0]?.id;
          });
          break;

        default:
          break;
      }
      const { statusCode, message } = response;
      if (statusCode === SUCCEED_CODE) {
        ElMessage.success(message);
      } else {
        ElMessage.error(message);
      }
    };

    // 删除文件
    const removeFile = (fileList, type) => {
      switch (type) {
        case "paymentVoucherFileList":
          detailData.value.paymentVoucherFileId = "";
          break;

        case "invoiceFileIdList":
          detailData.value.invoiceFileIdList = fileList.map((item) => {
            return item.response.data[0].id;
          });
          break;

        default:
          break;
      }
    };

    // 预览附件
    const priviewFile = (filePath) => {
      if (filePath.path) {
        window.open(filePath.path);
      } else {
        let path = filePath.response.data.find(
          (item) => item.fileName === filePath.name
        );
        window.open(path.filePath);
      }
    };

    // 删除结算单材料价格
    const deleteSettlementMaterial = (id) => {
      jointPlanApi.deleteSettlementMaterial({ id: id }).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success(message);
        } else {
          ElMessage.error(message);
        }
      });
    };

    // 履约列表
    const goListPage = () => {
      router.push({ path: "/jointPlan/detail", query: { id: lcPlanId.value } });
    };

    // 保存结算单
    const updateSettlement = () => {
      detailData.value.id = routeParams.value.id;
      jointPlanApi.updateSettlement(detailData.value).then((res) => {
        const { statusCode, message } = res;
        if (statusCode === SUCCEED_CODE) {
          ElMessage.success(message);
          goListPage();
        } else {
          ElMessage.error(message);
        }
      });
    };

    // 操作进度状态
    const handleCommitData = async () => {
      if (!formRef.value) return;
      await formRef.value.validate((valid) => {
        if (valid) {
          updateSettlement();
        } else {
          ElMessage.error("请检查必填项！");
        }
      });
    };

    return {
      contractManage,
      orderManage,
      acceptanceManage,
      settleManage,
      renderDom,
      detailData,
      acceptStatusDic,
      paymentMethodDic,
      pricingMethodDic,
      routeParams,
      currentProcess,
      processModal,
      currentEditProcess,
      currentEditProcessData,
      disabled,
      currentEditProcessRef,
      projectDocUploadUrl,
      userRole,
      editTabeRef,
      editTableIndex,
      editTableData,
      userRoleType,
      formRef,
      setRenderDom,
      contractDetail,
      settlementDetail,
      orderDetail,
      acceptDetail,
      handleDownloadFile,
      processVisible,
      setCurrentProcess,
      closeModal,
      commitEditProcess,
      uploadSuccess,
      uploadProgressFile,
      removeProgressFile,
      handleSaveTableEditRow,
      setTableEditRow,
      cancelEditRow,
      removeFile,
      priviewFile,
      deleteSettlementMaterial,
      goListPage,
      updateSettlement,
      handleCommitData,
    };
  },
};
